export default __webpack_public_path__ + "static/media/Young-Living.5921079c.svg";